const API = "https://api.wirelesspress.org";

export default API;